import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { Prevention } from './Prevention';

export const PreventionPage = () => {
  useTitle('Профилактические мероприятия');

  return (
    <Layout withFooter>
      <Prevention />
    </Layout>
  );
};
